/**
 * Main theme JavaScript
 */

(function() {
  'use strict';

  // Initialize theme
  function init() {
    console.log('Prince of Manifestation theme initialized');
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Add loading class removal
  window.addEventListener('load', function() {
    document.body.classList.add('loaded');
  });

})();
